import { GameFontStyle, GameLoaderFontStyle } from "@lib/js-slingo-pawnshop-core/dist";
import { ArcadeWheelStyle } from "@lib/titan2-slingo/dist/game/view/abstract/display/ArcadeWheel";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { Font, FontStroke } from "@lib/titan2/dist/game/control/properties/FontProperties";
import { FontMap } from "@lib/titan2/dist/game/manager/FontManager";
import { LanguageManager } from "@lib/titan2/dist/game/manager/LanguageManager";
import { CommonFontStyle, LoaderFontStyle } from "@lib/titan2/dist/game/view/style/CommonFontStyle";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { FontColour, FontShadows, FontStrokes, NormalisedFontStroke } from "./FontConstants";
/**
 * AbstractFontMap.ts
 */
export class AbstractFontMap extends FontMap {
    addMapping2(id, font, size, fill, uppercase, optionsPrefix) {
        const properties = this.addMapping(id, font, size, fill, uppercase);
        if (FontColour[optionsPrefix + "_STOPS"]) {
            properties.addGradientStops(FontColour[optionsPrefix + "_STOPS"]);
        }
        if (FontStrokes[optionsPrefix]) {
            if (FontStrokes[optionsPrefix] instanceof NormalisedFontStroke) {
                const stroke = new FontStroke(FontStrokes[optionsPrefix].colour, size / FontStrokes[optionsPrefix].thickness);
                properties.addStroke(stroke);
            }
            else {
                properties.addStroke(FontStrokes[optionsPrefix]);
            }
        }
        if (FontShadows[optionsPrefix]) {
            properties.addDropShadow(FontShadows[optionsPrefix]);
        }
        return properties;
    }
    createFontScale() {
        this.fontScale = new Dictionary();
        //this.fontScale.setValue(Locale.CHINESE, 0.7);
        //this.fontScale.setValue(Locale.LATVIAN, 1.3);
    }
    createFonts() {
        let locale = LanguageManager.getInstance().getLocale();
        if (locale.useNativeFont()) {
            this.createFontScale();
            this.outfitBlack = this.luckiestGuyRegular = this.lato = this.fontArcadeWheel = new Font(this.getNativeFont(locale), this.getFontScale(locale));
        }
        else {
            this.lato = new Font("Lato");
            this.fontArcadeWheel = new Font("League Spartan");
            this.outfitBlack = new Font("Outfit");
            this.luckiestGuyRegular = new Font("LuckiestGuy");
        }
        this.outfitBlack.setWeight("900");
        this.luckiestGuyRegular.setPaddingPercentage(0.15);
        this.outfitBlack.setPaddingPercentage(0.15);
    }
    getFontScale(locale) {
        let fontScale = 1.0;
        if (this.fontScale.containsKey(locale)) {
            fontScale = this.fontScale.getValue(locale);
        }
        return fontScale;
    }
    register() {
        this.addMapping2(LoaderFontStyle.PROGRESS, this.luckiestGuyRegular, 90, FontColour.LOADER, true, "LOADER");
        this.addMapping2(LoaderFontStyle.VERSION, this.luckiestGuyRegular, 40, FontColour.COPYRIGHT, true, "COPYRIGHT");
        this.addMapping2(LoaderFontStyle.PLAY_BUTTON, this.luckiestGuyRegular, 72, FontColour.PLAY_BUTTON, true, "PLAY_BUTTON");
        this.addMapping2(LoaderFontStyle.GUIDE_BODY, this.luckiestGuyRegular, 45, FontColour.LOADER, false, "LOADER").setLeading(-5);
        this.addMapping2(GameLoaderFontStyle.WIN_FIELD_SMALL, this.luckiestGuyRegular, 85, FontColour.LOADER_WIN, false, "LOADER_WIN").setLeading(-15);
        this.addMapping2(GameLoaderFontStyle.WIN_FIELD_LARGE, this.luckiestGuyRegular, 150, FontColour.LOADER_WIN, false, "LOADER_WIN").setLeading(-15);
        this.addMapping2(GameLoaderFontStyle.INFO_FIELD_LINE_1, this.luckiestGuyRegular, 52, FontColour.LOADER_INFO_FIELD_LINE_1, false, "LOADER_INFO_FIELD_LINE_1");
        this.addMapping2(GameLoaderFontStyle.INFO_FIELD_LINE_2, this.luckiestGuyRegular, 52, FontColour.LOADER_INFO_FIELD_LINE_2, false, "LOADER_INFO_FIELD_LINE_2");
        this.addMapping2(LoaderFontStyle.COPYRIGHT, this.luckiestGuyRegular, 25, FontColour.COPYRIGHT, true, "COPYRIGHT");
        this.addMapping2(GameLoaderFontStyle.COPYRIGHT_PORTRAIT, this.luckiestGuyRegular, 25, FontColour.COPYRIGHT, true, "COPYRIGHT");
        this.addMapping2(CommonFontStyle.DIALOG_BUTTON_0, this.luckiestGuyRegular, 48, FontColour.DEFAULT_DIALOG, true, "DEFAULT_DIALOG");
        this.addMapping2(CommonFontStyle.DIALOG_BUTTON_1, this.luckiestGuyRegular, 48, FontColour.DEFAULT_DIALOG, true, "DEFAULT_DIALOG");
        this.addMapping2(CommonFontStyle.DIALOG_BUTTON_2, this.luckiestGuyRegular, 48, FontColour.DEFAULT_DIALOG, true, "DEFAULT_DIALOG");
        this.addMapping2(CommonFontStyle.DIALOG_TITLE, this.luckiestGuyRegular, 64, FontColour.DEFAULT_DIALOG, true, "DEFAULT_DIALOG");
        this.addMapping2(CommonFontStyle.DIALOG_MESSAGE, this.luckiestGuyRegular, 50, FontColour.DEFAULT_DIALOG, true, "DEFAULT_DIALOG");
        this.addMapping(FontStyle.FREE_SPIN_SYMBOL, this.outfitBlack, 60, FontColour.FREE_SPIN_SYMBOL, true).addStroke(FontStrokes.FREE_SPIN_SYMBOL).setLeading(-8);
        this.addMapping2(CommonFontStyle.PRELOADER_MESSAGE, this.outfitBlack, 30, FontColour.DEFAULT_DIALOG, true, "DEFAULT_DIALOG");
        this.addMapping2(CommonFontStyle.DEMO_PLAY_LABEL, this.lato, 38, FontColour.DEFAULT_DIALOG, true, "DEFAULT_DIALOG");
        this.addMapping2(CommonFontStyle.OPTIONS_MENU, this.luckiestGuyRegular, 60, FontColour.OPTIONS, true, "OPTIONS");
        this.addMapping2(CommonFontStyle.RESPONSIBLE_GAMING_PANEL_TITLE, this.luckiestGuyRegular, 32, FontColour.DEFAULT_DIALOG, true, "DEFAULT_DIALOG");
        this.addMapping2(CommonFontStyle.RESPONSIBLE_GAMING_OPTION_BUTTON_DESELECTED, this.luckiestGuyRegular, 30, FontColour.DEFAULT_DIALOG, true, "DEFAULT_DIALOG");
        this.addMapping2(CommonFontStyle.RESPONSIBLE_GAMING_OPTION_BUTTON_SELECTED, this.luckiestGuyRegular, 30, FontColour.DEFAULT_DIALOG, true, "DEFAULT_DIALOG");
        this.addMapping(FontStyle.TEST_BUTTON, this.lato, 24, FontColour.TEST_BUTTON, true);
        this.addMapping(CommonFontStyle.SIGNPOSTING_TITLE, this.lato, 48, FontColour.SIGNPOSTING_TITLE);
        this.addMapping(CommonFontStyle.SIGNPOSTING_BODY, this.lato, 32, FontColour.SIGNPOSTING_BODY);
        this.addMapping2(GameFontStyle.SCATTER_PANEL_FIELD, this.outfitBlack, 36, FontColour.SCATTER_PANEL_FIELD, false, "SCATTER_PANEL_FIELD");
        //////////////////////////////////////////////////
        this.addMapping2(CommonFontStyle.STAKE_SELECTOR_AMOUNT, this.outfitBlack, 64, FontColour.OPTIONS, false, "OPTIONS");
        this.addMapping2(CommonFontStyle.STAKE_SELECTOR_LABEL, this.outfitBlack, 64, FontColour.OPTIONS, false, "OPTIONS");
        this.addMapping2(CommonFontStyle.STAKE_SELECTOR_VALUE_BUTTON, this.outfitBlack, 64, FontColour.OPTIONS, false, "OPTIONS");
        this.addMapping(ArcadeWheelStyle.FONT_COUNTER, this.fontArcadeWheel, 67, 0xffffff, true).addDropShadow(ArcadeWheelStyle.FONT_SHADOW_SMALL).addStroke(ArcadeWheelStyle.FONT_STROKE_SMALL);
        this.addMapping(ArcadeWheelStyle.FONT_INSTRUCTIONS, this.fontArcadeWheel, 75, 0xffffff, false).addDropShadow(ArcadeWheelStyle.FONT_SHADOW_LARGE).addStroke(ArcadeWheelStyle.FONT_STROKE_LARGE);
        this.addMapping(ArcadeWheelStyle.FONT_TOOLTIP_INFO, this.fontArcadeWheel, 75, 0xffffff, true);
        this.addMapping(ArcadeWheelStyle.FONT_SPIN_PRICE, this.fontArcadeWheel, 67, 0xffffff, true).addDropShadow(ArcadeWheelStyle.FONT_SHADOW_SMALL).addStroke(ArcadeWheelStyle.FONT_STROKE_SMALL);
        this.addMapping(ArcadeWheelStyle.FONT_TOOLTIP_LABEL, this.fontArcadeWheel, 144, 0xffffff, true);
    }
}
